import Util from "@/helper/Utility.js";
import mitt from "mitt";
/**
 * setting
 * @method setTitle
 * @method setMsg
 * @method setBtnOk
 * @method setTag
 * @method clearModal
 * action
 * @method show
 * @method hide
 * set event callback
 * @method onClickOk
 * @method onHidden
 * event
 * @event sendCallbackOk
 * @event sendCallbackHidden
 */
export function AlertModalController() {
    this.title = '';
    this.msg = '';
    this.btnOk = '';
    this.tag = '',
        this.busModal = new mitt();

    this.callbackOk = null;
    this.callbackHidden = null;

    //#region setter
    this.setTitle = function (title) {
        this.title = title;
        return this;
    };
    this.setMsg = function (msg) {
        this.msg = msg;
        return this;
    };
    this.setBtnOk = function (btnOk) {
        this.btnOk = btnOk;
        return this;
    };
    this.setTag = function (tag) {
        this.tag = tag;
        return this;
    };
    this.clearModal = function () {
        this.title = '';
        this.msg = '';
        this.btnOk = '';
        this.tag = '';
        this.callbackOk = null;
        this.callbackHidden = null;
        return this;
    };
    //#endregion setter

    //#region method
    this.show = function (type, opts = {}) {
        var config = {
            title: this.title,
            msg: this.msg,
            btnOk: this.btnOk,
            tag: this.tag,
            type: type,
            ...opts
        };
        this.busModal.emit('show', config);
    };
    this.hide = function () {
        this.busModal.emit('hide');
    };
    //#endregion method

    //#region event
    this.onClickOk = function (callback) {
        if (Util.isFunction(callback)) {
            this.callbackOk = callback;
        }
    },
        this.sendCallbackOk = function (data) {
            if (Util.isFunction(this.callbackOk)) {
                this.callbackOk(data);
            }
        };

    this.onHidden = function (callback) {
        if (Util.isFunction(callback)) {
            this.callbackHidden = callback;
        }
    };
    this.sendCallbackHidden = function (data) {
        if (Util.isFunction(this.callbackHidden)) {
            this.callbackHidden(data);
        }
    };
    //#endregion event
}
